// ***********************************  SUPER FORM STARTS HERE **********************************************

(function( jQuery ){
  /* ------------------------------------------------------------------ helpers */
  const $$ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$$ = (sel, ctx = document) => ctx.querySelectorAll(sel);

  const forms = $$$('.pp-superform');
  if (!forms.length) return;

  /* ------------------------------------------------------ delegation for clicks */
  document.body.addEventListener('click', e => {
    const btn  = e.target.closest('button');
    if (!btn) return;
    const form = btn.closest('.pp-superform');
    if (!form) return;

    if (btn.parentElement.classList.contains('buying-option')) {
      activate(btn);
      updateBuyingArea(form);
      updateJarTexts(form); // ✅ Add this line to refresh all jar prices
    } else if (btn.parentElement.classList.contains('jars-option')) {
      activate(btn);         updateBuyingArea(form); updateJarTexts(form);
    } else if (btn.parentElement.classList.contains('frequency-option')) {
      activate(btn);
    } else if (btn.classList.contains('add-to-cart')) {
      addToCart(form);
    }
  });

  /* ----------------------------------------------------------- first paint */
  forms.forEach(f => { updateBuyingArea(f); updateJarTexts(f); f.classList.remove('loading'); });

  /* ========================================================== functions */

  function activate(btn) {
    btn.parentElement.querySelectorAll('.active').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
  }

  function updateJarTexts(form) {
    const isSub = $$('.buying-option .active', form).dataset.option === 'subscribe';
    const jarButtons = $$$('.jars-option button', form);

    jarButtons.forEach(btn => {
      const txt = isSub ? btn.dataset.displayPerjarSub : btn.dataset.displayPerjarOnetime;
      const priceEl = btn.querySelector('.price-value');
      if (priceEl) priceEl.innerHTML = `${txt} each`;
    });
  }


  function updateBuyingArea(form) {
    const jar = $$('.jars-option .active', form);
    const oneBtn = $$('[data-option="one-time"]', form);
    const subBtn = $$('[data-option="subscribe"]', form);

    const one = oneBtn?.querySelector('.price-value');
    const sub = subBtn?.querySelector('.price-value');

    const onePrice = parseInt(jar.dataset.priceOnetime || "0");
    const subPrice = parseInt(jar.dataset.priceSubscribe || "0");
    const compareAt = parseInt(jar.dataset.compareAtPrice || "0");

    const displayOne = jar.dataset.displayOnetime;
    const displaySub = jar.dataset.displaySubscribe;
    const displayCompareOne = jar.dataset.displayCompareOnetime;
    const displayCompareSub = jar.dataset.displayCompareSubscribe;

    if (one) {
      one.innerHTML = (compareAt > onePrice && displayCompareOne)
        ? `<s>${displayCompareOne}</s> ${displayOne}`
        : `${displayOne}`;
    }

    if (sub && subBtn) {
      sub.innerHTML = (compareAt > subPrice && displayCompareSub)
        ? `<s>${displayCompareSub}</s> ${displaySub}`
        : `${displaySub}`;
    }

    // show / hide frequency box
    const subBox = $$('.frequency-option', form);
    const head   = $$('.delivery-heading', form);
    const subMode = $$('.buying-option .active', form).dataset.option === 'subscribe';

    if (subBox) subBox.style.display = subMode ? 'flex' : 'none';
    if (head)   head.style.display   = subMode ? 'block' : 'none';
    if (!subMode) {
      $$$('.jars-option button .frequency-label', form).forEach(span => span.remove());
    }


    // ✅ Auto-select delivery option based on jar count
    // if (subMode && subBox) {
    //   const activeJar = $$('.jars-option .active', form);
    //   const jarCount = parseInt(activeJar.dataset.jars || "1");
    //   const freqButtons = $$$('.frequency-option button', form);

      // remove previous active state
      // freqButtons.forEach(btn => btn.classList.remove('active'));

      // 1 Jar → index 0, 2 Jars → index 1, 4 Jars → index 2
    //   const index = Math.min(jarCount === 1 ? 0 : jarCount === 2 ? 1 : 2, freqButtons.length - 1);
    //   freqButtons[index].classList.add('active');

    //   updateVariantLabelsWithFrequency(form);
    // }

    // Handle Installment Block visibility + update
    const shippingInstallment = $$('.su-installment', form);
    const installmentValue = $$('.installment-value', form);
    const rawOnetimeHTML = jar?.dataset.displayOnetime;

    if (shippingInstallment && installmentValue) {
      if (subMode) {
        shippingInstallment.style.display = 'none';
      } else {
        shippingInstallment.style.display = 'block';

        if (rawOnetimeHTML) {
          updateInstallmentDisplay(rawOnetimeHTML, installmentValue);
        }
      }
    }

  }

  function addToCart(form) {
        console.log('🔍 Form element:', form);

        const activeJar = $('.jars-option .active', form)[0];  // ✅ Get the DOM element
        console.log('🔍 Active jar button:', activeJar);

        if (!activeJar) {
          console.error('❌ No active jar button found!');
          return;
        }

        const variantId = activeJar.dataset.variantId;
        console.log('🔍 Variant ID:', variantId);

        const activeBuying = $('.buying-option .active', form)[0];  // ✅ Get the DOM element
        const subMode = activeBuying?.dataset.option === 'subscribe';

        const planBtn = $('.frequency-option .active', form)[0];  // ✅ Get the DOM element
        const sellingPlan = subMode && planBtn ? planBtn.dataset.sellingPlanId : null;
        const quantity = 1;

        console.log('🔍 Adding to cart:', { variantId, subMode, sellingPlan, quantity });

        const btn = $('.add-to-cart', form)[0];  // ✅ Get the DOM element
        if (!btn) {
          console.error('❌ Add to cart button not found');
          return;
        }

        btn.disabled = true;
        btn.textContent = 'Adding…';

        const formData = new URLSearchParams({ id: variantId, quantity: quantity });
        if (sellingPlan) formData.append('selling_plan', sellingPlan);

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
          headers: {
            'X-Requested-With': 'XMLHttpRequest'
          }
        })
          .then(response => response.json())
          .then(data => {
            console.log('🔍 Cart response:', data);

            if (data.status === 422) {
              console.error(data.message);
            } else {
              // Dispatch cart:update event
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: {
                  resource: {},
                  sourceId: variantId.toString(),
                  data: {
                    source: 'product-form-component',
                    itemCount: quantity,
                    productId: data.product_id,
                    variantId: variantId
                  }
                }
              }));

              // Open cart drawer after a short delay
              setTimeout(() => {
                const cartDrawer = document.querySelector('cart-drawer-component');
                if (cartDrawer && typeof cartDrawer.open === 'function') {
                  cartDrawer.open();
                  console.log('✅ Cart drawer opened');
                }
              }, 300);
            }
          })
          .catch(error => {
            console.error("❌ Error adding to cart:", error);
          })
          .finally(() => {
            btn.disabled = false;
            btn.textContent = 'Add to Cart';
          });
      }

    // function updateVariantLabelsWithFrequency(form) {
    //   const subMode = $$('.buying-option .active', form).dataset.option === 'subscribe';
    //   const freqButtons = $$$('.frequency-option button', form);
    //   const jarButtons = $$$('.jars-option button', form);

    //   if (!subMode || !freqButtons.length || !jarButtons.length) return;

    //   jarButtons.forEach((btn, idx) => {
    //     const jars = parseInt(btn.dataset.jars || "1");

    //     const freqIndex = Math.min(jars === 1 ? 0 : jars === 2 ? 1 : 2, freqButtons.length - 1);
    //     const freqTextRaw = freqButtons[freqIndex]?.textContent?.trim();

    //     if (!freqTextRaw) return;

    //     const labelText = `Delivered Every ${freqTextRaw}`;

    //     const existingSpan = btn.querySelector('.frequency-label');
    //     if (existingSpan) existingSpan.remove();

    //     const titleEl = btn.querySelector('.price-title');
    //     if (titleEl && titleEl.parentNode) {
    //       const span = document.createElement('span');
    //       span.className = 'frequency-label';
    //       span.style.fontSize = '12px';
    //       span.style.color = '#666';
    //       span.style.display = 'block';
    //       span.textContent = labelText;

    //       titleEl.parentNode.insertBefore(span, titleEl.nextSibling);
    //     }
    //   });
    // }

  function decodeHTML(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  function extractAmountAndCurrency(htmlString) {
    const decoded = decodeHTML(htmlString); // e.g., 308,03 lei
  
    // Match optional symbol, number, then currency name/symbol/code
    const match = decoded.match(/([€£$])?\s*([\d.,]+)\s*(\w+)?/i);
    if (!match) return { amount: 0, symbol: "", currency: "" };
  
    let symbol = match[1] || "";
    let rawAmount = match[2];
    let currency = (match[3] || "").trim();
  
    // Normalize EU number formatting
    if (rawAmount.includes(',') && rawAmount.includes('.')) {
      rawAmount = rawAmount.replace(/\./g, '').replace(',', '.');
    } else if (rawAmount.includes(',') && !rawAmount.includes('.')) {
      rawAmount = rawAmount.replace(',', '.');
    }
  
    return {
      symbol: symbol.trim(),
      amount: parseFloat(rawAmount),
      currency
    };
  }


function updateInstallmentDisplay(displayAttr, valueEl) {
  const { symbol, amount, currency } = extractAmountAndCurrency(displayAttr);
  if (!amount || !valueEl) return;

  const quarter = amount / 4;

  // Convert to fixed 2 decimals, swap dot for comma, then remove ",00" if present
  const formatted = quarter
    .toFixed(2)
    .replace('.', ',')
    .replace(',00', ''); 

  valueEl.innerHTML = `${symbol}${formatted} ${currency}`.trim();
}

  /* ----------------------------- tiny debug helpers -------------------- */
  window.debugTile = sel => updateBuyingArea($$(sel));
  console.log('%c✓ slim JS loaded — no maths, no currency logic', 'color:#0a0');

  })( window.GemQuery || jQuery );


// ***********************************  SUPER FORM ENDS HERE **********************************************